import type { AccountType } from '@/types/services/assets'
import type { EntityType } from '@/types/services/root'

type friendlyAccountTypesOptions = {
  [key in AccountType]: string
}

type friendlyEntityTypesOptions = {
  [key in EntityType]: string
}

const friendlyTransferTypes = {
  deposit: 'Deposit',
  management: 'Management',
  standard: 'Standard',
  withdrawal: 'Withdrawal',
  fee_withdrawal: 'Fee Withdrawal',
  transaction: 'Transaction',
  fee: 'Fee',
}

const friendlyEntryTypes: friendlyAccountTypesOptions = {
  manual_entry: 'Crypto Asset',
  ico: 'Custom Entry',
  exchange: 'Exchange',
  blockchain: 'Blockchain',
}

const accountStatuses = {
  fail: 'Disconnected',
  done: 'Connected',
}

const friendlyEntityTypes: friendlyEntityTypesOptions = {
  portfolio: 'Portfolio',
  fund_product: 'Fund',
  root_user: 'User',
}

export {
  friendlyTransferTypes,
  friendlyEntryTypes,
  accountStatuses,
  friendlyEntityTypes,
}
